import { createContext, useContext } from "react";

import type { Impulse } from "~/tools/impulse";

const DropdownWithHostContext = createContext<null | Impulse<boolean>>(null);

export const DropdownWithHostContextProvider = DropdownWithHostContext.Provider;

export const useIsDropdownWithHostOpen = (): null | Impulse<boolean> => useContext(DropdownWithHostContext);
